
export default (store) => ({
  path: 'summary-focus',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const SummaryFocus = require('./containers/SummaryFocusContainer').default

      /*  Return getComponent   */
      cb(null, SummaryFocus)

    /* Webpack named bundle   */
    }, 'SummaryFocus')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/routes/SummaryFocus/index.js
 **/